import React from "react";
import MailBoxCanvas from "../shader/MailBox";
import Tilt from "react-parallax-tilt";

const Contact = () => {
  return (
    <div className="text-center mt-10">
      <div>
        <h1 className="text-4xl font-bold text-white text-center">Contact</h1>
      </div>
      <div className="flex h-96 ">
        <div className="w-2/4">
          <MailBoxCanvas />
        </div>
        <div className="w-2/4">
          <div className="flex justify-center">
            <Tilt>
              <a
                href="https://www.linkedin.com/in/g%C3%BCven-karabulut-b34b96260/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3536/3536505.png"
                  alt="linkedin"
                  className="w-28 h-28 object-contain mr-6"
                />
              </a>
            </Tilt>
            <Tilt>
              <a
                href="https://github.com/guvenkarabulut"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/512/733/733553.png"
                  alt="github"
                  className="w-28 h-28 object-contain mr-6"
                />
              </a>
            </Tilt>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
